<app-layout [isProducerArea]="true">
  <app-page-header
    [title]="'Minha página'"
    [titleIcon]="'pi pi-home'"
    [subtitle]="'Cadastre e gerencie as informações da sua página de produtor.'"
    [breadcrumbs]="[
      { label: 'Início', link: '/', icon: 'pi pi-home' },
      { label: 'Área do produtor', link: '/producer-area', icon: 'pi pi-chart-bar' },
      { label: 'Minha página', icon: 'pi pi-home' },
    ]"></app-page-header>
  <div class="create-producers-page__content">
    <div class="create-producers-page__body container-fluid">
      <form [formGroup]="form" (ngSubmit)="onSubmit()" class="create-producers-page__form" style="gap: 30px">
        <div class="card">
          <div class="card-body">
            <p class="h4 mb-3">Perfil</p>
            <div class="row g-3">
              <div class="col-12 col-md-6">
                <div class="form-group">
                  <label class="form-label" for="organizer_page">Endereço da página</label>
                  <div class="create-producers-page__url-row">
                    <span class="create-producers-page__form-link-yes7">www.yes7tickets.com.br/</span>
                    <input
                      placeholder="Ex: meu-evento"
                      type="text"
                      class="form-control"
                      id="organizer_page"
                      formControlName="organizer_page" />
                  </div>
                  @if (controls.organizer_page.touched && controls.organizer_page.hasError("required")) {
                    <div class="text-danger">O endereço da página é obrigatório.</div>
                  }
                </div>
              </div>

              <div class="col-12 col-md-6">
                <div class="form-group">
                  <label class="form-label" for="name">Nome do Organizador*</label>
                  <input
                    placeholder="Nome do perfil"
                    type="text"
                    class="form-control"
                    id="name"
                    formControlName="name" />

                  @if (controls.name.touched && controls.name.hasError("required")) {
                    <div class="text-danger">O nome do organizador é obrigatório.</div>
                  }
                </div>
              </div>

              <div class="col-12 col-md-6">
                <div class="form-group">
                  <label class="form-label" for="thumbnail">Logo (imagem de perfil da página)</label>

                  @if (thumbnailPreview) {
                    <div class="image-preview mb-2">
                      <img [src]="thumbnailPreview" alt="Logo do produtor" />

                      <div class="d-flex gap-2 flex-wrap">
                        <app-button icon="pi pi-pencil" type="button" (btnClick)="enableThumbnailChange()">
                          Alterar logo
                        </app-button>

                        <app-button icon="pi pi-trash" type="button" (btnClick)="clearThumbnail()">
                          Remover logo
                        </app-button>
                      </div>
                    </div>
                  }

                  @if (showThumbnailInput) {
                    <input
                      id="thumbnail"
                      type="file"
                      class="form-control form-control-md"
                      (change)="onThumbnailFileChange($event)" />
                  }
                </div>
              </div>

              <div class="col-12 col-md-6">
                <div class="form-group">
                  <label class="form-label" for="banner">Banner (imagem de capa da página)</label>

                  @if (bannerPreview) {
                    <div class="image-preview mb-2">
                      <img [src]="bannerPreview" alt="Banner do produtor" />

                      <div class="d-flex gap-2 flex-wrap">
                        <app-button icon="pi pi-pencil" type="button" (btnClick)="enableBannerChange()">
                          Alterar banner
                        </app-button>

                        <app-button icon="pi pi-trash" type="button" (btnClick)="clearBanner()">
                          Remover banner
                        </app-button>
                      </div>
                    </div>
                  }

                  @if (showBannerInput) {
                    <input
                      id="banner"
                      type="file"
                      class="form-control form-control-md"
                      (change)="onBannerFileChange($event)" />
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="card">
          <div class="card-body">
            <p class="h4 mb-3">Descrição</p>
            <div class="form-group">
              <p-editor
                id="description"
                formControlName="description"
                placeholder="Descrição do evento"
                [ngClass]="'text-editor'"
                [style]="{ height: '320px', width: '100%' }" />
            </div>
          </div>
        </div>
        <div class="card">
          <div class="card-body">
            <p class="h4 mb-3">Redes sociais</p>
            <div class="row g-3">
              <div class="col-12 col-md-6">
                <div class="form-group">
                  <label class="form-label" for="instagram_username"> <i class="pi pi-instagram"></i> Instagram </label>
                  <input
                    placeholder="Ex: seu_usuario"
                    type="text"
                    class="form-control"
                    id="instagram_username"
                    formControlName="instagram_username" />
                  <small class="form-text text-muted d-inline-flex align-items-center gap-1">
                    Digite só o nome de usuário.
                    <i
                      class="pi pi-question-circle"
                      matTooltip="Você também pode colar a URL completa do perfil (https://instagram.com/seu_usuario) que extraímos o nome automaticamente."
                      matTooltipPosition="above"></i>
                  </small>
                  @if (controls.instagram_username.touched && controls.instagram_username.hasError("pattern")) {
                    <div class="text-danger">Use só letras, números, ponto ou underscore (até 30 caracteres).</div>
                  }
                </div>
              </div>

              <div class="col-12 col-md-6">
                <div class="form-group">
                  <label class="form-label" for="facebook_username"> <i class="pi pi-facebook"></i> Facebook </label>
                  <input
                    placeholder="Ex: sua-pagina"
                    type="text"
                    class="form-control"
                    id="facebook_username"
                    formControlName="facebook_username" />
                  <small class="form-text text-muted d-inline-flex align-items-center gap-1">
                    Digite só o nome de usuário/página.
                    <i
                      class="pi pi-question-circle"
                      matTooltip="Você também pode colar a URL completa da página (https://facebook.com/sua-pagina) que extraímos o nome automaticamente."
                      matTooltipPosition="above"></i>
                  </small>
                  @if (controls.facebook_username.touched && controls.facebook_username.hasError("pattern")) {
                    <div class="text-danger">Use só letras, números, ponto ou hífen.</div>
                  }
                </div>
              </div>

              <div class="col-12 col-md-6">
                <div class="form-group">
                  <label class="form-label" for="whatsapp_phone"> <i class="pi pi-whatsapp"></i> WhatsApp </label>
                  <input
                    placeholder="Ex: 11999999999"
                    type="tel"
                    inputmode="numeric"
                    class="form-control"
                    id="whatsapp_phone"
                    formControlName="whatsapp_phone" />
                  <small class="form-text text-muted d-inline-flex align-items-center gap-1">
                    Digite só os números.
                    <i
                      class="pi pi-question-circle"
                      matTooltip="Sem DDI, assumimos Brasil (55). Você também pode colar a URL completa do WhatsApp — extraímos o número automaticamente."
                      matTooltipPosition="above"></i>
                  </small>
                  @if (controls.whatsapp_phone.touched && controls.whatsapp_phone.hasError("pattern")) {
                    <div class="text-danger">Informe um número válido (10 a 15 dígitos).</div>
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="card">
          <div class="card-body">
            <p class="h4 mb-3">Configurações extras</p>
            <div class="form-check form-switch">
              <input
                type="checkbox"
                class="form-check-input"
                id="past_events"
                role="switch"
                formControlName="past_events" />
              <label class="form-check-label create-producers-page__form-checkbox-label" for="past_events">
                Mostrar eventos passados/encerrados na página
              </label>
            </div>
          </div>
        </div>

        <div class="d-flex gap-2 flex-wrap justify-content-end">
          <app-button
            type="button"
            styleType="outlined"
            [disabled]="!controls.organizer_page.value"
            (btnClick)="openProducerPage()">
            Visualizar minha página
          </app-button>
          <app-button type="submit" [disabled]="!form.valid || isSaving" [loading]="isSaving">
            {{ isSaving ? "Salvando" : "Salvar" }}
          </app-button>
        </div>
      </form>
      <footer class="create-producers-page__footer">Yes 7 Tickets SA © Copyright 2024</footer>
    </div>
  </div>
</app-layout>
